<template>
    <div class="text-red-600 text-sm mt-0.5 w-full">{{ error }}</div>
</template>

<script>
export default {
    props: {
        error: {
            type: String,
        },
    },
}
</script>
